// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Q1DS","productName":"Table_productName__NOtne"};